export const loanCalculatorData = [
  {
    id: 1,
    heading: "SBI Personal Loan EMI Calculator: Plan Your Finances with Ease",
    subHeading:
      "Use the SBI Personal Loan EMI Calculator to get an accurate estimate of your monthly EMI. Whether you’re looking to consolidate debt, fund a personal project, or manage urgent expenses, understanding your EMI helps you manage your finances effectively. With SBI’s EMI calculator, you can instantly calculate your monthly installment based on your loan amount, tenure, and interest rate.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
